import type { AxiosInstance, AxiosResponse } from 'axios';
import type { FileUploadItem } from '@gov-nx/core/hooks';
import type {
	SouborySouborStavDto,
	VypisyudajuDokumentInfoDto,
} from '../generated';
import { fileToFormData } from '../utils/utils';

export const downloadFileQuery = async ({
	id,
	axiosInstance,
}: {
	axiosInstance: AxiosInstance;
	id: string;
}): Promise<AxiosResponse> =>
	axiosInstance.get('/api/v1/vypisyudaju/' + id + '/stahnout', {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		responseType: 'blob',
	});

export const saveToDocumentsQuery = async ({
	axiosInstance,
	id,
}: {
	id: string;
	axiosInstance: AxiosInstance;
}): Promise<VypisyudajuDokumentInfoDto> => {
	const { data } = await axiosInstance.post(
		'/api/v1/vypisyudaju/' + id + '/ulozitdodokumentu',
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);

	return data;
};

export const uploadFileQuery = async (
	axiosInstance: AxiosInstance,
	file: FileUploadItem
): Promise<AxiosResponse<string>> => {
	const data = new FormData();
	data.append('nazevSouboru', fileToFormData(file));

	const response = await axiosInstance.post('/api/v1/soubory', data, {
		headers: { 'Content-Type': 'multipart/form-data' },
	});
	return response;
};

export const checkFileQuery = async (
	axiosInstance: AxiosInstance,
	fileId: string
): Promise<SouborySouborStavDto> => {
	const { data } = await axiosInstance.get(`/api/v1/soubory/${fileId}/stav`);
	return data;
};
